import { render, staticRenderFns } from "./Suspend.html?vue&type=template&id=7889e7e9&scoped=true&external"
import script from "./Suspend.js?vue&type=script&lang=js&external"
export * from "./Suspend.js?vue&type=script&lang=js&external"
import style0 from "./Suspend.vue?vue&type=style&index=0&id=7889e7e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889e7e9",
  null
  
)

export default component.exports